﻿import jquery from "jquery";

export default ((window as any).jQuery = (window as any).$ = jquery);
